const SPACE = ' ';
export const getAbbreviation = (str, abbreviationLength) => {
    var _a;
    const trimStr = str.replace(/[^a-zа-яё\d\s]/gi, '').trim();
    if (!trimStr || trimStr.length < abbreviationLength) {
        return trimStr.toUpperCase();
    }
    const strParts = trimStr.split(SPACE);
    let abbreviation = trimStr;
    if (strParts.length > 1) {
        const firstLetter = strParts[0].charAt(0);
        const secondLetter = (_a = strParts[strParts.length - 1]) === null || _a === void 0 ? void 0 : _a.charAt(0);
        abbreviation = `${firstLetter}${secondLetter}`.toUpperCase();
    }
    return abbreviation.slice(0, abbreviationLength).toUpperCase();
};
